import React, { useState, useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import * as turf from "@turf/turf"; // Assuming you're using Turf.js for calculations
import { Rnd } from "react-rnd";
import "./popupselect.css";
import "leaflet/dist/leaflet.css";
import { ToastContainer, toast } from "react-toastify";     

export default function AreaCalc() {
  const {   tools,Canvas, map, vis,layerControls } = useContext(GlobalContext);

  const [show, setShow] = useState(false);
  const [vectors, setVectors] = useState([]);
  const toolRef = useRef(null);
  const [selLayer1, setSelLayer1] = useState(null);
  const [geometryOptions, setGeometryOptions] = useState([]);
  const [selectedGeometry, setSelectedGeometry] = useState("");
  const [showAttributeTable, setShowAttributeTable] = useState(false);
  const [calculatedProperties, setCalculatedProperties] = useState([]);

  useEffect(() => {
    if (layerControls && Canvas) {
      setVectors(Canvas.getLayers());
    }
    setSelLayer1(null); 
    setGeometryOptions([]);
  }, [show, Canvas, layerControls]);

  const handleLayerChange = (e) => {
    const selectedLayerName = e.target.value;
    setSelLayer1(selectedLayerName);
    updateGeometryOptions(selectedLayerName);
  };

  const updateGeometryOptions = (layerName) => {
    const selectedLayer = Canvas.getLayerData(layerName);
    if (!selectedLayer) return;
  
    const geojson = selectedLayer;
    if (!geojson.features || !geojson.features.length) return;
  
    const geomType = geojson.features[0].geometry.type;
  
    let options = [];
    if (geomType === "Polygon" || geomType === "MultiPolygon") {
      options = [
        "Area in sqm",
        "Area in sqkm",
        "Area in sqft",
        "Area in acres",
        "Area in hectares",
        "Perimeter in m",
        "Perimeter in km",
        "Perimeter in feet"
      ];
    } else if (geomType === "LineString" || geomType === "MultiLineString") {
      options = [
        "Length in m",
        "Length in km",
        "Length in feet"
      ];
    } else if (geomType === "Point") {
      options = ["Lat Long (Degree Decimal)"];
    }
  
    setGeometryOptions(options);
    setSelectedGeometry("");
  };
  

  const handleGeometryChange = (e) => {
    setSelectedGeometry(e.target.value);
  };

  const handleCalculate = () => {
    if (!selLayer1 || !selectedGeometry) {
      alert("Please select both a layer and a geometry calculation.");
      return;
    }
  
    const selectedLayer = Canvas.getLayerData(selLayer1);
    if (!selectedLayer || !selectedLayer.features?.length) return;
  
    selectedLayer.features.forEach((feature) => {
      if (
        feature.geometry.type === "MultiPolygon" ||
        feature.geometry.type === "Polygon"
      ) {
        const polygons =
          feature.geometry.type === "MultiPolygon"
            ? feature.geometry.coordinates
            : [feature.geometry.coordinates];
  
        polygons.forEach((polygonCoords) => {
          const polygon = turf.polygon(polygonCoords);
  
          const areaSqm = turf.area(polygon);
          const areaSqkm = areaSqm * 0.000001;
          const areaSqft = areaSqm * 10.7639;
          const areaAcres = areaSqm * 0.000247105;
          const areaHa = areaSqm * 0.0001;
  
          const perimeterKM = turf.length(turf.polygonToLine(polygon));
          const perimeterM = perimeterKM * 1000;
          const perimeterFt = perimeterM * 3.28084;
  
          if (selectedGeometry === "Area in sqm")
            feature.properties[selectedGeometry] = areaSqm.toFixed(4);
          if (selectedGeometry === "Area in sqkm")
            feature.properties[selectedGeometry] = areaSqkm.toFixed(4);
          if (selectedGeometry === "Area in sqft")
            feature.properties[selectedGeometry] = areaSqft.toFixed(4);
          if (selectedGeometry === "Area in acres")
            feature.properties[selectedGeometry] = areaAcres.toFixed(4);
          if (selectedGeometry === "Area in hectares")
            feature.properties[selectedGeometry] = areaHa.toFixed(4);
  
          if (selectedGeometry === "Perimeter in m")
            feature.properties[selectedGeometry] = perimeterM.toFixed(4);
          if (selectedGeometry === "Perimeter in km")
            feature.properties[selectedGeometry] = perimeterKM.toFixed(4);
          if (selectedGeometry === "Perimeter in feet")
            feature.properties[selectedGeometry] = perimeterFt.toFixed(4);
        });
      } else if (
        feature.geometry.type === "MultiLineString" ||
        feature.geometry.type === "LineString"
      ) {
        const lines =
          feature.geometry.type === "MultiLineString"
            ? feature.geometry.coordinates
            : [feature.geometry.coordinates];
  
        lines.forEach((lineCoords) => {
          const line = turf.lineString(lineCoords);
          const lengthKM = turf.length(line);
          const lengthM = lengthKM * 1000;
          const lengthFt = lengthM * 3.28084;
  
          if (selectedGeometry === "Length in km")
            feature.properties[selectedGeometry] = lengthKM.toFixed(4);
          if (selectedGeometry === "Length in m")
            feature.properties[selectedGeometry] = lengthM.toFixed(4);
          if (selectedGeometry === "Length in feet")
            feature.properties[selectedGeometry] = lengthFt.toFixed(4);
        });
      } else if (feature.geometry.type === "Point") {
        const [longitude, latitude] = feature.geometry.coordinates;
        feature.properties.Longitude = longitude;
        feature.properties.Latitude = latitude;
      }
    });
  
    Canvas.updateLayerData(selLayer1, selectedLayer);
  
    // Optional: update popups
    selectedLayer.features.forEach((feature) => {
      const layer = map._layers[feature.id];
  
      if (layer) {
        let popupContent =
          "<table class='table' style='width: 100%; font-size: 14px;'><thead><tr><th>Title</th><th>Attribute</th></tr></thead><tbody>";
  
        for (let key in feature.properties) {
          popupContent += `<tr><th>${key}</th><td>${feature.properties[key]}</td></tr>`;
        }
  
        popupContent += "</tbody></table>";
  
        layer.setPopupContent(popupContent);
      }
    });
  
    const newCalculatedProperties = selectedLayer.features.map(
      (feature) => feature.properties
    );
    console.log('newCalculatedProperties')
    setCalculatedProperties(newCalculatedProperties);
    alert("Geometry Calculation completed successfully!");
    // setShowAttributeTable(true);
  };
  
  const handleCheckboxToggle = (rowIndex) => {
    setCalculatedProperties((prev) => {
      const updated = [...prev];
      const current = { ...updated[rowIndex] };
      current.selection = !current.selection;
      updated[rowIndex] = current;
  
      // also update the real Canvas layer so state stays consistent
      const layer = Canvas.getLayerData(selLayer1);
      if (layer?.features?.[rowIndex]) {
        const feature = layer.features[rowIndex];
  
        feature.properties.selection = current.selection;
  
        if (current.selection) {
          highlightFeatureOnMap(feature);
        } else {
          unhighlightFeatureOnMap(feature);
        }
  
        Canvas.updateLayerData(selLayer1, {
          ...layer,
          features: [...layer.features],
        });
      }
  
      return updated;
    });
  };
  
  const highlightFeatureOnMap = (feature) => {
    try {
      const layer = L.geoJSON(feature, {
        style: { color: "yellow", weight: 4 },
      }).addTo(map);
  
      feature._highlightLayer = layer;
  
      const bounds = layer.getBounds();
      if (bounds.isValid()) {
        map.flyToBounds(bounds, { maxZoom: 16 });
      }
    } catch (err) {
      console.error("Highlight error:", err);
    }
  };
  
  const unhighlightFeatureOnMap = (feature) => {
    try {
      if (feature._highlightLayer) {
        map.removeLayer(feature._highlightLayer);
        delete feature._highlightLayer;
      }
    } catch (err) {
      console.error("Unhighlight error:", err);
    }
  };
  
  
 return (
  <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">

    {/* ── Trigger Button ── */}
    <button
      className="btn text-white"
      title="Geometry Calculation"
      onClick={() => setShow(!show)}
      style={{ backgroundColor: "black", width: "40px", height: "40px", borderRadius: "50%", border: "none" }}
    >
      <i className="fa-solid fa-chart-area" />
    </button>

    {show && (
      <div ref={toolRef} className="toolsvis" style={{ display: "flex", flexDirection: "column", width: "240px", padding: "10px 12px" }}>

        {/* ── Header ── */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          paddingBottom: "8px", marginBottom: "10px",
          borderBottom: "1px solid rgba(255,255,255,0.12)"
        }}>
          <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
            <i className="fa-solid fa-chart-area" style={{ marginRight: "6px", fontSize: "11px" }} />
            Geometry Calculation
          </span>
          <span
            onClick={() => setShow(false)}
            style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
          >
            &times;
          </span>
        </div>

        {/* ── Content ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

          {/* Layer Select */}
          <select
            onChange={handleLayerChange}
            value={selLayer1}
            className="form-select text-white swipe-options"
            style={{ backgroundColor: "transparent", fontSize: "12px", border: "1px solid rgba(255,255,255,0.25)", color: "white", borderRadius: "4px" }}
          >
            <option value="">Select Vector Layer</option>
            {vectors.map((layerName, idx) => (
              <option key={idx} value={layerName}>{layerName}</option>
            ))}
          </select>

          {/* Geometry Option Select */}
          {geometryOptions.length > 0 && (
            <select
              onChange={handleGeometryChange}
              value={selectedGeometry}
              className="form-select text-white swipe-options"
              style={{ backgroundColor: "transparent", fontSize: "12px", border: "1px solid rgba(255,255,255,0.25)", color: "white", borderRadius: "4px" }}
            >
              <option value="">Select Geometry Option</option>
              {geometryOptions.map((opt, idx) => (
                <option key={idx} value={opt}>{opt}</option>
              ))}
            </select>
          )}

          {/* Calculate Button */}
          <button
            onClick={handleCalculate}
            className="btn btn-primary border-0"
            style={{ width: "100%", height: "30px", fontSize: "12px" }}
          >
            Calculate Geometry
          </button>

          {/* Show Attribute Table Checkbox */}
          <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0, cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={showAttributeTable}
              onChange={() => setShowAttributeTable(!showAttributeTable)}
            />
            <span style={{ fontSize: "12px", color: "white" }}>Show Attribute Table</span>
          </label>

        </div>
      </div>
    )}

    {/* ── Attribute Table Modal ── */}
    {showAttributeTable && (
      <div className="modal-overlay" style={{ zIndex: 1000 }}>
        <Rnd
          default={{ x: 0, y: 0, width: 450, height: 350 }}
          minWidth={450} minHeight={350}
          maxWidth={1200} maxHeight={450}
          bounds="window"
          style={{ left: tools ? "60px" : "360px", backgroundColor: "white", zIndex: 1000 }}
          enableResizing={{ top: true, bottom: true, left: true, right: true, topLeft: true, topRight: true, bottomLeft: true, bottomRight: true }}
        >
          <div className="modal-content" style={{ overflow: "scroll", pointerEvents: "auto" }}>

            {/* Modal Header */}
            <div style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "8px 12px", borderBottom: "1px solid #ddd"
            }}>
              <h6 style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>Attribute Table</h6>
              <i
                className="fa-solid fa-xmark"
                onClick={() => setShowAttributeTable(false)}
                style={{ fontSize: "16px", cursor: "pointer", color: "#e74c3c" }}
              />
            </div>

            {/* Table */}
            {calculatedProperties.length > 0 && (
              <div className="attribute-table-container" onMouseDown={(e) => e.stopPropagation()}>
                <div className="table-scroll">
                  <table className="table-striped">
                    <thead>
                      <tr>
                        {Object.keys(calculatedProperties[0]).map((key, idx) => (
                          <th key={idx}>{key}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {calculatedProperties.map((props, rowIdx) => (
                        <tr key={rowIdx} className={props.selection ? "highlight-row" : ""}>
                          {Object.keys(props).map((key, colIdx) => (
                            <td key={colIdx}>
                              {key === "selection" ? (
                                <input
                                  type="checkbox"
                                  checked={props.selection}
                                  onChange={() => handleCheckboxToggle(rowIdx)}
                                />
                              ) : props[key]}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

          </div>
        </Rnd>
      </div>
    )}

    <ToastContainer position="bottom-right" theme="light" draggable={false} />
  </div>
);
}
